import React from 'react';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ChildProps } from 'react-apollo';
import {
  Input_core_apimessages_DatadogError,
  SearchUserDatadogErrors,
} from '../schemas/rql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCLoadingBars } from '@reverbdotcom/cadence/components';

interface DatadogErrorProps {
  errors: Input_core_apimessages_DatadogError[];
}

interface StoredError {
  key: string;
  type: string;
  timestamp: string;
  content: string;
  context: string;
}

interface ExternalProps {
  storedErrors: StoredError[];
  userId: string;
}

type Props = ChildProps<ExternalProps, SearchUserDatadogErrors.Query>;

export const SEARCH_USER_DATADOG_ERRORS_QUERY = gql`
  query SearchUserDatadogErrors(
    $input: Input_core_apimessages_AdminUserDatadogErrorsSearchRequest
  ) {
    datadogErrorsSearch(input: $input) {
      datadogErrors {
        key
        type
        content
        context
        timestamp
      }
    }
  }
`;

const withSearchUserDatadogErrorsQuery = withGraphql<ExternalProps, SearchUserDatadogErrors.Query, SearchUserDatadogErrors.Variables>(
  SEARCH_USER_DATADOG_ERRORS_QUERY,
  {
    options: ({ userId }) => {
      return {
        errorPolicy: 'all',
        ssr: false, // admin only
        variables: {
          input: {
            userId: userId.toString(),
          },
        },
      };
    },
  },
);

export const ErrorRows = ({ errors }: DatadogErrorProps) => {
  return (
    <>
      {errors.map(error => (
        <tr key={error.key}>
          <td>{error.type}</td>
          <td>{error.timestamp}</td>
          <td><SanitizedRender html={error.content} /></td>
          <td>{error.context}</td>
        </tr>
      ))}
    </>
  );
};

export const AdminUserErrors = ({ data, storedErrors }: Props) => {
  return storedErrors.length > 0 ? (
    <table className="table">
      <thead>
        <tr>
          <th>Type</th>
          <th>Time</th>
          <th>Errors</th>
          <th>Context</th>
        </tr>
      </thead>
      <tbody>
        <ErrorRows errors={storedErrors} />
        { data.loading ? (
          <tr key="loading">
            <td colSpan={4}>
              <div className="d-flex fx-justify-center pt-1">
                <RCLoadingBars />
              </div>
            </td>
          </tr>
        ) : (
          <ErrorRows errors={data?.datadogErrorsSearch?.datadogErrors || []} />
        )}
      </tbody>
    </table>
  ) : (
    <p>No recent Reverb Payments, PayPal, or shipping label errors</p>
  );
};

export default withSearchUserDatadogErrorsQuery(AdminUserErrors);
